var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4401 44.7666C55.9017 44.7666 55.3634 44.5682 54.9384 44.1432L36.4651 25.6699C35.1051 24.3099 32.8951 24.3099 31.5351 25.6699L13.0617 44.1432C12.2401 44.9649 10.8801 44.9649 10.0584 44.1432C9.23672 43.3216 9.23672 41.9616 10.0584 41.1399L28.5317 22.6666C31.5351 19.6632 36.4367 19.6632 39.4684 22.6666L57.9417 41.1399C58.7634 41.9616 58.7634 43.3216 57.9417 44.1432C57.5167 44.5399 56.9784 44.7666 56.4401 44.7666Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.19be1fa0d3f3c056199380aea5823551.svg";
export { ForwardRef as ReactComponent };